import React, { useEffect, useState } from 'react';
import { all_routes } from '../../../../core/data/routes/all_routes';
import './style.css'
import { TKN_PasswordInput } from '../../../components/inputfields/input';
import apiService from '../../../../api/authentication-service';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../../../core/data/redux/store';
import { logout } from '../../../../core/data/redux/action';
import { validateOldPassword_NewPassword_ConfirmPassword } from '../../../../../src/helper/validate';
import en from '../../../../en/en';
import { Spinner } from 'react-bootstrap';
import { PasswordStrengthComponent } from '../../../components/login/login_component';
import { TitleSubtitleDescription } from '../../../components/about_us/about_us_extra';
import { ButtonTextOnly_BlueoverlayLinkTag, } from '../../../components/buttons/button';

const ProviderResetPassword = () => {
    const routes = all_routes;
    const [oldpassword, setOldPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [oldPasswordError, setOldPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');
    const [serverError, setServerError] = useState('');
    const [passwordResponse, setPasswordResponse] = useState({
        passwordResponseText: '',
        passwordResponseKey: '',
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const dispatch: AppDispatch = useDispatch();
    const navigateTo = useNavigate();

    const minLength = 8;
    const maxLength = 15;

    const resetErrors = () => {
        setOldPasswordError('');
        setPasswordError('');
        setConfirmPasswordError('');
        setServerError('');
    };

    const handleSubmit = () => {
        resetErrors();
        let isValid = true;
        const ispasswordValid = validateOldPassword_NewPassword_ConfirmPassword(oldpassword, password, confirmPassword);

        if (ispasswordValid["status"] === "false") {

            setOldPasswordError(ispasswordValid["oldPasswordError"]);
            setPasswordError(ispasswordValid['newPasswordError']);
            setConfirmPasswordError(ispasswordValid["confirmPasswordError"]);
            isValid = false;
        };

        if (oldpassword && password && oldpassword === password) {
            setServerError("New password cannot be the same as the old password.");
            isValid = false;
        }

        if (isValid) {
            setIsLoading(true);
            setServerError('');
            sendchangeOldPasswordRequest();
        }
    };

    const sendchangeOldPasswordRequest = () => {

        apiService.changeOldPassword(changeOldPasswordRequest()).then((response) => {

            changeOldPasswordResponse(response?.data);
        }).catch((error) => {

            // console.log('error', error);
        });
    }

    const userId = useSelector((state: any) => {
        return state.user.user_id
    });

    const changeOldPasswordRequest = () => ({
        old_password: oldpassword,
        new_password: password,
        confirm_password: confirmPassword,
        user_id: userId
    });

    const handleLogout = () => {
        dispatch(logout());
        // Optional: clear local storage or any other storage
        localStorage.removeItem('UserDetails');
        localStorage.removeItem('VendorDetails');
        // Redirect to login or home page
        navigateTo('../authentication/login');

    };

    const changeOldPasswordResponse = (response: any) => {
        setIsLoading(false);

        if (response) {
            const status = response?.status;
            if (status && status === true) {

                try {
                    handleLogout();
                } catch (error) {

                    // console.error('Error resetting password:', error);
                }
            } else {
                if (response?.message) {
                    setServerError(response.message);
                } else {
                    setServerError('Unable to reset your password. Please try again.');
                }
            }

        } else {

            setServerError("Old password is wrong...Current password is wrong...check once and try again!");
        };
    };

    const onChangePassword = (password: string) => {
        setPassword(password);

        if (password.match(/^$|\s+/)) {
            setPasswordResponse({
                passwordResponseText: en.PASSWORD_CONDITION,
                passwordResponseKey: '',
            });
        } else if (password.length === 0) {
            setPasswordResponse({
                passwordResponseText: '',
                passwordResponseKey: '',
            });
        } else if (password.length < 8) {
            setPasswordResponse({
                passwordResponseText: en.PASSWORD_CONDITION,
                passwordResponseKey: '0',
            });
        } else if (
            password.search(/[a-z]/) < 0 ||
            password.search(/[A-Z]/) < 0 ||
            password.search(/[0-9]/) < 0
        ) {
            setPasswordResponse({
                passwordResponseText: en.PASSWORD_CONDITION,
                passwordResponseKey: '1',
            });
        } else if (password.search(/(?=.*?[#?!@$%^&*-])/) < 0) {
            setPasswordResponse({
                passwordResponseText: en.PASSWORD_CONDITION,
                passwordResponseKey: '2',
            });
        } else {
            setPasswordResponse({
                passwordResponseText: '',
                passwordResponseKey: '3',
            });
        }
    };

    const checkPasswordRequirements = (password: any) => {
        const hasMinimumLength = password.length >= 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecialChar = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
        return hasMinimumLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    }

    const handleOldPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setOldPassword(value);
        if (value.length < maxLength + 1) {
            setOldPasswordError('');
        } else {
            setOldPasswordError(en.CHAR_LIMIT);
        }
    }

    const handleNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setPassword(value);
        if (value.length < maxLength + 1) {
            setPasswordError('');
        } else {
            setPasswordError(en.CHAR_LIMIT);
        }
        onChangePassword(value);
    }

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setConfirmPassword(value);
        if (value.length < maxLength + 1) {
            setConfirmPasswordError('');
        } else {
            setConfirmPasswordError(en.CHAR_LIMIT);
        }
    }

    return (
        <div className="provider-body">
            <div className="main-wrapper">
                <div className="page-wrapper">
                    <div className="content container-fluid" style={{ width: '97.5%' }}>
                        <div className="col-lg-6" style={{ maxWidth: 420 }}>
                            <div className="widget-title">
                                <TitleSubtitleDescription title='Reset Password' description={['Your new password must be different from previous passwords.']} classname='padding-0px-custom padding-btm-15px' titleclassname='vendor-title-custom' />
                                <div className="log-form">
                                    <div className="form-group">
                                        <TKN_PasswordInput
                                            label={'Old Password'}
                                            value={oldpassword}
                                            onChange={handleOldPasswordChange}
                                            required={true}
                                        />
                                        {oldPasswordError !== '' && <div className='error'>{oldPasswordError}</div>}
                                        <TKN_PasswordInput
                                            label={'New Password'}
                                            value={password}
                                            onChange={handleNewPasswordChange}
                                            required={true}
                                        />
                                        {passwordError !== '' && <div className='error'>{passwordError}</div>}
                                        {password !== '' && !passwordError && !checkPasswordRequirements(password) && (
                                            <div style={{ color: 'red' }}>
                                                {en.PASSWORD_REQUIREMENTS}
                                            </div>
                                        )}
                                        <PasswordStrengthComponent PasswordResponse={passwordResponse} />
                                    </div>
                                    <div className="form-group">
                                        <TKN_PasswordInput
                                            label={'Confirm Password'}
                                            value={confirmPassword}
                                            onChange={handleConfirmPasswordChange}
                                            required={true}
                                        />
                                        {confirmPasswordError !== '' && <div className='error'>{confirmPasswordError}</div>}
                                    </div>
                                    <div className="error-message" style={{ color: 'red', fontSize: 18, marginBottom: '5px' }}>
                                        {serverError}
                                    </div>
                                </div>
                                <ButtonTextOnly_BlueoverlayLinkTag label={'Save Change'} fullWidth={true} className='btn btn-primary signupheight-custom btn-custom-center login-btn' type='submit' onClick={handleSubmit} disabled={isLoading} isLoading={isLoading} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mouse-cursor cursor-outer"></div>
                <div className="mouse-cursor cursor-inner"></div>
            </div>
        </div>
    );
};

export default ProviderResetPassword;